<msc-feat-correction-list [corrections]="corrections" [title]="instance.title"></msc-feat-correction-list>
